var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.isEmpty)?_c('div',_vm._g(_vm._b({class:[_vm.variant, 'alert']},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',[(_vm.$slots.icon)?_c('div',[_vm._t("icon")],2):_vm._e(),_c('div',[_vm._t("default")],2)])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }